var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { AchooKeyworkInputFieldComponent } from '../../../core/achoo-keywork-input-field/achoo-keywork-input-field.component';
import { ProjectService } from '../../../services/project/project.service';
import { Project } from '../../../../models/project/project';
import { UserService } from '../../../services/user.service';
import { ValidationHandlerService } from '../../../core/validation-handler.service';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { EventTrackerService, Page, UserActionType, ActionSource, TargetType } from '../../../services/event-tracker/event-tracker.service';
import { CommonConstant } from '../../../app.constants';
import { ActivePage } from '../../../../models/event-tracker';
import { BlockedReason, InvalidAction, WallType } from '../../../../models/user';
var EditProjectComponent = /** @class */ (function () {
    function EditProjectComponent(projectService, userService, validateErrorHandler, modalService, translate, eventTracker) {
        this.projectService = projectService;
        this.userService = userService;
        this.validateErrorHandler = validateErrorHandler;
        this.modalService = modalService;
        this.translate = translate;
        this.eventTracker = eventTracker;
        this.countryList = [];
        this.showCountryList = true;
        this.closeBottomBarCallback = new EventEmitter();
        this.beforeCreateOrUpdateProject = new EventEmitter();
        this.canCreateOrUpdateProject = true;
    }
    EditProjectComponent.prototype.closeEditProject = function () {
        this.modalService.close();
        this.closeBottomBarCallback.emit({ isReloadList: false });
    };
    EditProjectComponent.prototype.beforeAddingNewMontion = function (mention) {
        this.canCreateOrUpdateProject = false;
    };
    EditProjectComponent.prototype.afterAddingNewMentionForProject = function (mention) {
        this.canCreateOrUpdateProject = true;
    };
    EditProjectComponent.prototype.createOrEditProject = function () {
        var _this = this;
        // disable button create/update
        this.canCreateOrUpdateProject = false;
        var isCreated = this.project.id <= 0;
        this.project.advertiserId = this.userService.getCompanyId();
        this.project.keywords = this.mentionInput.mentions;
        if (this.mentionInput.countries.length > 0) {
            this.project.countries = this.mentionInput.countries;
        }
        else {
            this.project.countries = [CommonConstant.INTERNATIONAL_ID];
        }
        var errors = this.projectService.validateProject(this.project);
        if (errors.length > 0) {
            this.validateErrorHandler.shouldDisplayErrors(true);
            this.validateErrorHandler.updateErrors(errors);
            // enable button create/update
            this.canCreateOrUpdateProject = true;
        }
        else {
            this.beforeCreateOrUpdateProject.emit();
            this.projectService.createOrEditProject(this.project).subscribe(function (res) {
                if (!res || !res.data) {
                    return;
                }
                // reload project list
                var data = {
                    isReloadList: true,
                    isCreatedNew: isCreated,
                    projectId: res.data.id,
                    projectName: res.data.name,
                    projectData: res.data
                };
                // track event to Segment
                _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.PROJECT, {
                    id: res.data.id,
                    name: res.data.name,
                    type: Page.PROJECT
                }, __assign({ action: UserActionType.CREATE, source: ActionSource.ACTION_VIEW }, _this.project), undefined, {
                    type: _this.activePage && _this.activePage.type,
                    name: _this.activePage && _this.activePage.name,
                    id: _this.activePage && _this.activePage.id
                });
                // close bottombar
                if (_this.closeBottomBarCallback.observers.length > 0) {
                    _this.closeBottomBarCallback.emit(data);
                }
                else {
                    _this.projectService.triggerCreateOrUpdateProject(_this.project);
                }
                _this.modalService.open(_this.notificationAfterProjectUpdateSuccess, null, true);
                // enable button create/update
                _this.canCreateOrUpdateProject = true;
            }, function (err) {
                _this.closeBottomBarCallback.emit({
                    isError: true,
                    isCreated: isCreated
                });
                if (err.error.data === 'invalid_level') {
                    _this.userService.doInvalidActionByLevel('Add Mention', err.error.message);
                    _this.sendInvalidActionToSegment();
                }
                // enable button create/update
                _this.canCreateOrUpdateProject = true;
            });
        }
    };
    EditProjectComponent.prototype.sendInvalidActionToSegment = function () {
        var maxValue = this.userService.maxListeningMentions;
        var desiredValue = this.project.keywords.length;
        var detailAction = new InvalidAction(true, BlockedReason.ACCOUNT_WALL, WallType.USAGE_LIMIT, 'Project Mention Limit', true, maxValue, desiredValue, this.userService.accountLevelName);
        this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.PROJECT, {
            id: this.project.id,
            name: this.project.name,
            type: TargetType.PROJECT
        }, {
            action: UserActionType.UPDATE,
        }, undefined);
    };
    EditProjectComponent.prototype.closeNotification = function (e) {
        this.modalService.close();
    };
    EditProjectComponent.prototype.closeWarningPopup = function () {
        this.modalService.close();
    };
    EditProjectComponent.prototype.showWarningBeforeCancelingProject = function () {
        this.modalService.openInCenter(this.warningCancelEditProject);
    };
    EditProjectComponent.prototype.getNotificationContent = function () {
        if (this.project && this.project.id > 0) {
            return this.translate.instant('project.save_success');
        }
        else {
            return this.translate.instant('project.create_success');
        }
    };
    Object.defineProperty(EditProjectComponent.prototype, "actionSource", {
        get: function () {
            return ActionSource.ACTION_VIEW;
        },
        enumerable: true,
        configurable: true
    });
    return EditProjectComponent;
}());
export { EditProjectComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/edit-project/edit-project.component.ts.pre-build-optimizer.js